import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const clinicBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_TRAINING_API_URL || "https://api.training.nexalifecare.com",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  }
});

const clinicBaseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await clinicBaseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    if (window.location.pathname !== "/login") {
      localStorage.setItem("returnAfterLogin", window.location.pathname);
      window.location.replace("/login");
    }
  }

  return result;
};

export const clinicTrainingApi = createApi({
  reducerPath: "clinicTrainingApi",
  baseQuery: clinicBaseQueryWithReauth,  // 👈 swapped here
  tagTypes: ["Modules", "Exams", "Progress"],
  endpoints: (builder) => ({
    getModules: builder.query({
      query: () => ({ url: "/api/training/modules/", method: "GET" }),
      providesTags: ["Modules"]
    }),

    getModuleById: builder.query({
      query: (id) => ({ url: `/api/training/modules/${id}/`, method: "GET" }),
      providesTags: (_result, _err, id) => [{ type: "Modules", id }]
    }),

    getExam: builder.query({
      query: () => ({ url: "/api/training/exams/", method: "GET" }),
      providesTags: ["Exams"]
    }),

    getExamById: builder.query({
      query: (id) => ({ url: `/api/training/exams/${id}/`, method: "GET" }),
      providesTags: (_result, _err, id) => [{ type: "Exams", id }]
    }),

      getExamResult: builder.query({
      query: () => ({ url: "/api/training/certificates/", method: "GET" }),
      providesTags: ["Exams"]
    }),

    getExamResultById: builder.query({
      query: (id) => ({ url: `/api/training/certificates/${id}/`, method: "GET" }),
      providesTags: (_result, _err, id) => [{ type: "Exams", id }]
    }),

    submitExam: builder.mutation({
      query: ({ id, answers }) => ({
        url: `/api/training/exams/${id}/submit/`,
        method: "POST",
        body: { answers }
      })
    }),

    // ── Progress Endpoints ──────────────────────────────────
    getProgress: builder.query({
      query: () => ({ url: "/api/training/progress/", method: "GET" }),
      providesTags: ["Progress"]
    }),

    updateProgress: builder.mutation({
      query: ({ module_id, section_id, mark_completed }) => ({
        url: "/api/training/progress/update_progress/",
        method: "POST",
        body: { module_id, section_id, mark_completed }
      }),
      invalidatesTags: ["Progress"]
    })
  })
});

export const {
  useGetModulesQuery,
  useGetModuleByIdQuery,
  useGetExamQuery,
  useGetExamByIdQuery,
  useSubmitExamMutation,
  useGetExamResultQuery,
  useGetExamResultByIdQuery,
  useGetProgressQuery,
  useUpdateProgressMutation
} = clinicTrainingApi;